import { SET_FILTER_DATA, SET_FILTER_JOBID, SHOW_DUPLICATE, SHOW_DUPLICATE_RESET } from "../types"

const initialState = {
	fileTypes: [],
	dateRange: { startDate: "", endDate: "" },
	from: [],
	to: [],
	tags: [],
	commentsBy: [],
	view: "",
	filterJobId: "",
	showDuplicate: true,
	subject: "",
	has_attachment: [],
}
// eslint-disable-next-line
export default function (state = initialState, action) {
	switch (action.type) {
		case SET_FILTER_DATA:
			return {
				...state,
				...action?.payload,
			}
		case SET_FILTER_JOBID:
			return {
				...state,
				filterJobId: action?.payload,
			}
		case SHOW_DUPLICATE:
			return {
				...state,
				showDuplicate: action?.payload?.data,
			}
		case SHOW_DUPLICATE_RESET:
			return {
				...state,
				showDuplicate: true,
			}
		default:
			return state
	}
}
